/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrendAnalyticsData
 */
export interface TrendAnalyticsData {
    /**
     * 
     * @type {string}
     * @memberof TrendAnalyticsData
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof TrendAnalyticsData
     */
    value: number;
}


/**
 * Check if a given object implements the TrendAnalyticsData interface.
 */
export function instanceOfTrendAnalyticsData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "key" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function TrendAnalyticsDataFromJSON(json: any): TrendAnalyticsData {
    return TrendAnalyticsDataFromJSONTyped(json, false);
}

export function TrendAnalyticsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrendAnalyticsData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': json['key'],
        'value': json['value'],
    };
}

export function TrendAnalyticsDataToJSON(value?: TrendAnalyticsData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'value': value.value,
    };
}

